import { lazy } from "react";

export { WORK_CONDITIONS_CHANGE_REQUEST_PATH } from "./path";
export const WorkConditionsChangeRequestPage = lazy(() => import("./page"));
